import { render } from "./TakesTblDetails.vue?vue&type=template&id=eca52dc2&scoped=true"
import script from "./TakesTblDetails.vue?vue&type=script&lang=js"
export * from "./TakesTblDetails.vue?vue&type=script&lang=js"

import "./TakesTblDetails.vue?vue&type=style&index=0&id=eca52dc2&scoped=true&lang=css"

import exportComponent from "D:\\www\\Centroid\\Frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eca52dc2"]])

export default __exports__